import {
  FETCH_EMP_DISCRIPENCY_REQUEST,
  FETCH_EMP_DISCRIPENCY_SUCCESS,
  FETCH_EMP_DISCRIPENCY_FAILURE,
  FETCH_ATTENDANCE_SUMMARY_REQUEST,
  FETCH_ATTENDANCE_SUMMARY_SUCCESS,
  FETCH_ATTENDANCE_SUMMARY_FAILURE,
  FETCH_LOCATIONS_REQUEST,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAILURE,
} from "../constants/EmpDiscripencyConstants";
import EmpDiscripencyService from "../service/EmpDiscripencyService";

// Fetch all locations
export const fetchLocations = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_LOCATIONS_REQUEST });
    const data = await EmpDiscripencyService.getLocations();
    dispatch({
      type: FETCH_LOCATIONS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_LOCATIONS_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch locations",
    });
  }
};

// Fetch attendance summary for all locations
export const fetchAttendanceSummary = (date) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ATTENDANCE_SUMMARY_REQUEST });
    const data = await EmpDiscripencyService.getAttendanceSummary(date);
    dispatch({
      type: FETCH_ATTENDANCE_SUMMARY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ATTENDANCE_SUMMARY_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch attendance summary",
    });
  }
};

// Fetch absent employees for a specific location
export const fetchEmpDiscripency = (date, location) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EMP_DISCRIPENCY_REQUEST });
    const data = await EmpDiscripencyService.getAll(date, location);
    dispatch({
      type: FETCH_EMP_DISCRIPENCY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_EMP_DISCRIPENCY_FAILURE,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch absent details",
    });
  }
};



// import {
//   FETCH_EMP_DISCRIPENCY_REQUEST,
//   FETCH_EMP_DISCRIPENCY_SUCCESS,
//   FETCH_EMP_DISCRIPENCY_FAILURE,
//   FETCH_ATTENDANCE_SUMMARY_REQUEST,
//   FETCH_ATTENDANCE_SUMMARY_SUCCESS,
//   FETCH_ATTENDANCE_SUMMARY_FAILURE,
// } from "../constants/EmpDiscripencyConstants";
// import EmpDiscripencyService from "../service/EmpDiscripencyService";

// // Fetch attendance summary for all locations
// export const fetchAttendanceSummary = (date) => async (dispatch) => {
//   try {
//     dispatch({ type: FETCH_ATTENDANCE_SUMMARY_REQUEST });
//     const data = await EmpDiscripencyService.getAttendanceSummary(date);
//     dispatch({
//       type: FETCH_ATTENDANCE_SUMMARY_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_ATTENDANCE_SUMMARY_FAILURE,
//       payload:
//         error.response?.data?.message ||
//         error.message ||
//         "Failed to fetch attendance summary",
//     });
//   }
// };

// // Fetch absent employees for a specific location
// export const fetchEmpDiscripency = (date, location) => async (dispatch) => {
//   try {
//     dispatch({ type: FETCH_EMP_DISCRIPENCY_REQUEST });
//     const data = await EmpDiscripencyService.getAll(date, location);
//     dispatch({
//       type: FETCH_EMP_DISCRIPENCY_SUCCESS,
//       payload: data,
//     });
//   } catch (error) {
//     dispatch({
//       type: FETCH_EMP_DISCRIPENCY_FAILURE,
//       payload:
//         error.response?.data?.message ||
//         error.message ||
//         "Failed to fetch absent details",
//     });
//   }
// };